import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

/* eslint-disable @typescript-eslint/naming-convention */
// We want these to match the API schema as closely as possible

export const geminiJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    tools: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: { type: 'string' },
          type: { type: 'string', enum: ['Function', 'codeExecution'] },
          description: { type: 'string' },
        },
        required: ['name', 'type'],
      },
    },
    toolConfig: {
      type: 'object',
      properties: {
        toolTimeoutMs: { type: 'integer', minimum: 0 },
      },
    },
    safetySettings: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          category: {
            type: 'string',
            enum: [
              'HARM_CATEGORY_HATE_SPEECH',
              'HARM_CATEGORY_SEXUALLY_EXPLICIT',
              'HARM_CATEGORY_DANGEROUS_CONTENT',
              'HARM_CATEGORY_HARASSMENT',
            ],
          },
          threshold: { type: 'integer', minimum: 0, maximum: 100 },
        },
        required: ['category', 'threshold'],
      },
    },
    systemInstruction: {
      type: 'object',
      properties: {
        parts: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              text: { type: 'string' },
            },
            required: ['text'],
          },
        },
      },
    },
    generationConfig: {
      type: 'object',
      properties: {
        temperature: { type: 'number', minimum: 0, maximum: 1 },
        maxOutputTokens: { type: 'integer', minimum: 1 },
        topP: { type: 'number', minimum: 0, maximum: 1 },
        topK: { type: 'integer', minimum: 0 },
      },
    },
    cachedContent: { type: 'string', pattern: '^cachedContents/[^/]+$' },
    temperature: { type: 'number' },
    maxOutputTokens: { type: 'integer' },
    topP: { type: 'number' },
    topK: { type: 'number' },
    candidateCount: { type: 'number' },
    presencePenalty: { type: 'number' },
    frequencyPenalty: { type: 'number' },
    stopSequences: { type: 'array', items: { type: 'string' } },
    seed: { type: 'integer' },
    responseMimeType: { type: 'string' },
    responseLogprobs: { type: 'boolean' },
    logProbs: { type: 'integer' },
    audioTimestamp: { type: 'boolean' },
    thinkingConfig: {
      type: 'object',
      properties: {
        thinkingLevel: {
          type: 'string',
          enum: ['minimal', 'low', 'medium', 'high'],
        },
        thinkingBudget: { type: 'integer', minimum: -1 },
        includeThoughts: { type: 'boolean' },
      },
    },
  },
  required: ['contents'],
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const geminiSchemaProperties: DeepReadonly<JSONSchema7> = geminiJsonSchema;

export const retrieveGeminiParameters = (): string[] => Object.keys(geminiJsonSchema.properties);
